import { GridComparatorFn } from '@mui/x-data-grid';

/** Sorts date columns by millis; nulls last in ascending order. */
export const dateSortComparator: GridComparatorFn<number | null> = (a, b) => {
  if (a == null && b == null) {
    return 0;
  }
  if (a == null) {
    return 1;
  }
  if (b == null) {
    return -1;
  }
  return a - b;
};

/** Ensures each row has a stable, unique id for MUI DataGrid (avoids duplicate rows on sort). */
export function withUniqueGridRowIds<T>(
  rows: T[],
  getBaseId: (row: T) => string | number | null | undefined,
): (T & { __gridRowId: string })[] {
  return rows.map((row, index) => {
    const base = getBaseId(row);
    const __gridRowId = base != null ? `${base}-${index}` : `row-${index}`;
    return { ...row, __gridRowId };
  });
}
